export default {
    tokenExpired: false,
};